module.exports = __webpack_public_path__ + "img/jornay-logo.0b05435f.png";